document.addEventListener('DOMContentLoaded', () => {
    const caseStudiesSection = document.querySelector('.case-studies');
    if (!caseStudiesSection) return;

    const tabs = document.querySelectorAll('.cs-tab-btn');
    const grids = {
        seo: document.querySelector('.cs-grid-seo'),
        web: document.querySelector('.cs-grid-web'),
        website: document.querySelector('.cs-grid-web'),
        pa: document.querySelector('.cs-grid-pa'),
        branding: document.querySelector('.cs-grid-branding'),
        smm: document.querySelector('.cs-grid-smm')
    };

    // Tab Switching
    tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
            const targetTab = e.currentTarget.getAttribute('data-tab');
            if (!targetTab) return;

            // Update active states across all buttons (header and offcanvas)
            document.querySelectorAll('.cs-tab-btn').forEach(t => {
                if (t.getAttribute('data-tab') === targetTab) {
                    t.classList.add('active');
                } else {
                    t.classList.remove('active');
                }
            });

            // Smoothly center the active tab in the horizontal tabs container
            const horizontalTabs = document.querySelector('.case-studies__header-bottom .case-studies-tabs, .seo-cs-cat-tabs-wrap .case-studies-tabs');
            if (horizontalTabs) {
                const centerActiveTab = () => {
                    const activeBtn = horizontalTabs.querySelector(`.cs-tab-btn[data-tab="${targetTab}"]`);
                    if (activeBtn) {
                        const containerRect = horizontalTabs.getBoundingClientRect();
                        const btnRect = activeBtn.getBoundingClientRect();
                        const scrollOffset = (btnRect.left - containerRect.left) + horizontalTabs.scrollLeft - (containerRect.width / 2) + (btnRect.width / 2);
                        horizontalTabs.scrollTo({
                            left: Math.max(0, scrollOffset),
                            behavior: 'smooth'
                        });
                    }
                };
                centerActiveTab();
                setTimeout(centerActiveTab, 50);
            }

            // Hide all grids
            Object.values(grids).forEach(grid => {
                if(grid) {
                    grid.classList.remove('active');
                }
            });

            // Show target grid
            if (grids[targetTab]) {
                grids[targetTab].classList.add('active');
            }
        });
    });
    
    // Sticky Filter Logic
    const stickyFilter = document.querySelector('.case-studies-sticky-filter');
    const header = document.querySelector('.case-studies__header');

    if (stickyFilter && header) {
        window.addEventListener('scroll', () => {
            const headerRect = header.getBoundingClientRect();
            const sectionRect = caseStudiesSection.getBoundingClientRect();
            
            // If the header has scrolled out of view (top < 0), and we are still inside the section
            if (headerRect.bottom < 0 && sectionRect.bottom > window.innerHeight / 2) {
                stickyFilter.classList.add('is-sticky');
            } else {
                stickyFilter.classList.remove('is-sticky');
            }
        });
    }
});
